import React from "react";

export function mapChildrenIndexedByType(children, childHandler) {
  const childTypeCounters = {};
  return React.Children.map(children, (child) => {
    if (!child || !child.type) return child;
    const childName = child.type.displayName || child.type.name || "Component";
    const childIndex = childTypeCounters[childName] || 0;
    childTypeCounters[childName] = childIndex + 1;
    return childHandler(child, childIndex);
  });
}
